import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import EntityExampleWrapperNew from 'client/components/core/EntityExampleWrapper/EntityExampleWrapperNew'
import CommonShippingFees from 'common/components/entities/ShippingFees'
import {
  SelectedShipping,
  ShippingFeesInterface,
} from 'common/types/entities/ShippingFeesInterface'
import React, { useState } from 'react'
import { mockedShippingResponse } from 'src/shared/mocks/shipping'

type ShippingFeesProps = {
  entity: ShippingFeesInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

const ShippingFees = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: ShippingFeesProps) => {
  const [selectedShipping, setSelectedShipping] =
    useState<SelectedShipping | null>(null)

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <EntityExampleWrapperNew label="entities.shipping_fees.example_warning">
        <CommonShippingFees
          isLoading={false}
          selectedShipping={selectedShipping}
          onChange={setSelectedShipping}
          entity={entity}
          shipping={mockedShippingResponse}
        />
      </EntityExampleWrapperNew>
    </BaseEntityNew>
  )
}

export default ShippingFees
